import 'uni-pages';import Vue from 'vue';
import App from './demo/App';
import store from './demo/store';

import uView from 'uview-ui';
Vue.use(uView);

import { Setting, Mobile, Request } from './index';

// 初始化参数
const init = () => {
  Mobile.init(); // 使用移动版默认配置
  Setting.setRootUrl(process.env.VUE_APP_ROOT_URL);
  Setting.setRootKey(process.env.VUE_APP_ROOT_KEY);
  Setting.setFileKey(process.env.VUE_APP_FILE_KEY);
  Setting.appId = 'wx11cc76bf2fa971ad'; // 小牛
  console.log('init settings', process.env.NODE_ENV, Setting.getAll());
  // 默认头像
  Setting.defaultAvatar = require('static/logo.png');
  // 错误拦截
  Request.addErrorFilter(err => {
    console.log('捕捉到错误', err);
    if (err && err.code === 'rest999') {
      // 返回true告知手动处理错误,终止默认错误处理链
      return true;
    }
  });
};
init();

App.mpType = 'app';

//
const app = new Vue({
  store,
  ...App,
});
app.$mount();
// 让app全局可操作
Setting.app = app;
// 调试api
// Request.setApiMod('https://api.suboat.com/api/example/user/graphql', 'http://127.0.0.1:8080/api/v1/user/graphql');
// 小程序静默登录
app.$store.dispatch('user/setting', { isLoginAuto: false }); // false: 不进行自动登录
app.$store.dispatch('user/detail').then();
// app.$store.dispatch('wallet/walletList').then();
// app.$store.dispatch('user/detail').then(d => {
//   console.log('u1', d);
// });
// app.$store.dispatch('user/detail').then(d => {
//   console.log('u2', d);
// });